"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveLienAttestation = exports.getUserMerlocs = exports.getMilestoneData = exports.getAppLead = exports.clearData = exports.SAVE_LIEN_ATTESTATION = exports.GET_USER_MERLOCS = exports.GET_MILESTONE_DATA = exports.GET_APP_LEAD = exports.CLEAR_LEAD_DATA = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _ajax = require("./ajax");

var _httpActions = require("./http-actions");

var _reduxActions = require("redux-actions");

var CONTEXT = '/app-merloc';
var APP_CONTEXT = "".concat(CONTEXT, "/secure/api/v1/application/heloc");
var GET_APP_LEAD = 'MERLOC::GET_APP_LEAD';
exports.GET_APP_LEAD = GET_APP_LEAD;
var GET_USER_MERLOCS = 'MERLOC::GET_USER_MERLOCS';
exports.GET_USER_MERLOCS = GET_USER_MERLOCS;
var CLEAR_LEAD_DATA = 'MERLOC::CLEAR_LEAD_DATA';
exports.CLEAR_LEAD_DATA = CLEAR_LEAD_DATA;
var GET_MILESTONE_DATA = 'MERLOC::GET_MILESTONE_DATA'; // stuffed into Heloc reducer

exports.GET_MILESTONE_DATA = GET_MILESTONE_DATA;
var SAVE_LIEN_ATTESTATION = 'MERLOC::SAVE_LIEN_ATTESTATION';
exports.SAVE_LIEN_ATTESTATION = SAVE_LIEN_ATTESTATION;

var getAppLead = function getAppLead(leadUuid) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _ajax.ajaxGet)(GET_APP_LEAD, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(CONTEXT, "/external/api/v1/merloc/leads/").concat(leadUuid), null, null, false));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getAppLead = getAppLead;

var saveLienAttestation = function saveLienAttestation(data) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(dispatch) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", (0, _ajax.ajaxPut)(SAVE_LIEN_ATTESTATION, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(APP_CONTEXT, "/lien-attestation"), data));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.saveLienAttestation = saveLienAttestation;

var getMilestoneData = function getMilestoneData(appUuid) {
  return /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(dispatch) {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", (0, _ajax.ajaxGet)(GET_MILESTONE_DATA, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(APP_CONTEXT, "/milestones/").concat(appUuid), null, null, false));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

exports.getMilestoneData = getMilestoneData;

var getUserMerlocs = function getUserMerlocs() {
  return /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(dispatch) {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", (0, _ajax.ajaxGet)(GET_USER_MERLOCS, dispatch, "".concat((0, _httpActions.baseUrl)()).concat(APP_CONTEXT, "/all")));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};

exports.getUserMerlocs = getUserMerlocs;
var clearData = (0, _reduxActions.createAction)(CLEAR_LEAD_DATA);
exports.clearData = clearData;